import React, { useEffect, useRef } from 'react';
import $i18n from 'panda-i18n';
import { useSetState } from 'ahooks';
import { AreaChart } from 'bizcharts';
import { getWarehouseCode, vToLabel } from '@/utils';
import { getPersonDatas } from './index.services';
import { State, ListProps, ResProps } from './index.interface';
import { Loading } from '@fpxfd/next';
import { PERSON_TYPE } from '@/const';

const PersonBoard = () => {
  const [state, setState] = useSetState<State>({
    personList: [],
    loading: false,
    numList: [],
  });

  const personRef: React.MutableRefObject<ListProps[]> = useRef([]);
  personRef.current = state.personList;
  const loadRef: React.MutableRefObject<boolean> = useRef(false);
  loadRef.current = state.loading;
  const numListRef: React.MutableRefObject<[]> = useRef([]);
  numListRef.current = state.numList;

  const initDatas = () => {
    const d: ListProps[] = [];
    !personRef.current?.length && setState({ loading: true });
    const arr: [] = [];
    getPersonDatas({ warehouseCode: getWarehouseCode() })
      .then((inRes) => {
        const result = [...inRes];
        result &&
          PERSON_TYPE?.forEach((e) => {
            const current: ResProps = result.filter((x: ResProps) => x.operationNode === e.value)[0];
            if (arr.indexOf(current?.onlineNum) === -1) {
              arr.push(current?.onlineNum);
            } else if (arr.indexOf(current?.freeNum) === -1) {
              arr.push(current?.freeNum);
            }

            d.push({
              name: $i18n.get({ id: 'JobCount.four_px', dm: '作业人数' }),
              type: vToLabel(PERSON_TYPE, current?.operationNode),
              key: current?.operationNode,
              person: current?.onlineNum,
            });

            d.push({
              name: $i18n.get({ id: 'NumberOfIdlePeople.four_px', dm: '空闲人数' }),
              type: vToLabel(PERSON_TYPE, current?.operationNode),
              key: current?.operationNode,
              person: current?.freeNum,
            });
          });
      })
      .finally(() => {
        if (JSON.stringify(d) !== JSON.stringify(personRef.current)) {
          setState({
            personList: d,
            loading: false,
            numList: arr,
          });
        }
      });
  };

  useEffect(() => {
    initDatas();
    const timer = setInterval(() => {
      initDatas();
    }, 10000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const cellCount = () => {
    const max = Math.max.apply(null, numListRef.current);
    if (numListRef.current.length > 8) {
      return 8;
    } else if (max > 1000 && numListRef.current.length < 4) {
      return 4;
    } else return numListRef.current.length;
  };

  return (
    <Loading visible={loadRef.current}>
      <AreaChart
        title={{
          visible: true,
          text: $i18n.get({ id: 'PersonnelDistribution.four_px', dm: '人员分布' }),
        }}
        autoFit
        padding="auto"
        data={state.personList}
        xField={'type'}
        yField={'person'}
        xAxis={{
          line: {
            visible: false,
          },
          label: {
            autoRotate: true,
            autoHide: false,
          },
          tickLine: {
            visible: false,
          },
        }}
        yAxis={{
          tickLine: {
            visible: false,
          },
          tickCount: cellCount(),
          line: {
            visible: false,
          },
        }}
        renderer="svg"
        seriesField="name"
        color={['#005ADC', '#1AA4E3']}
      />
    </Loading>
  );
};

export default PersonBoard;
